import { createContext } from "react";

const TileContext = createContext({});
TileContext.displayName = "tile";

export default TileContext;
